import React from 'react'
import { ContainerInfo } from './styled'
import { LineDivider } from '../../../../../../../../Components/CustomUi/LineDivider'
import { Render } from '../../../../../../../../Components/CustomUi/render'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { Warning } from '../../../../../../../../Components/CustomUi/warning'
import type { EstadoAlerta } from '../iconeAlerta/meta/estadoAlerta'

interface Props {
  /** Estado único da linha, decidido pelo pai (`IconeAlerta`) — mesma fonte do ícone. */
  estado: EstadoAlerta
  dataSafraConsultoria: any[]
  cod_safra_conta: number
  laboratorio_nome: string
  chamarModalInconsistencia: () => void
}

export const InfoAdicionais: React.FC<Props> = ({
  estado,
  cod_safra_conta,
  dataSafraConsultoria,
  laboratorio_nome,
  chamarModalInconsistencia,
}) => {

  // Só erro e inconsistência abrem o modal de detalhe (têm observação do laboratório).
  const temInconsistencia = estado.tipo === 'erro' || estado.tipo === 'inconsistencia'

  return (
    <ContainerInfo>
      <div className='conteudo'>
        <div>
          <h3
            style={{
              padding: '0',
              margin: '0',
              fontSize: '16px',
              fontWeight: 'bold',
            }}
          >
            Informações adicionais
          </h3>
        </div>
        <LineDivider />

        {/* Linha de status: nomeia o que o ícone da linha significa. Nos estados
            com observação do laboratório ela é clicável e abre o detalhe. */}
        <Render condition={temInconsistencia}>
          <div className='inconsistencia' onClick={() => chamarModalInconsistencia()}>
            <FontAwesomeIcon fontSize={15} icon={estado.icone} color={estado.cor} />
            <label
              style={{
                padding: '0',
                marginTop: '2px',
                fontSize: '14px',
                fontWeight: 'bold',
              }}
            >
              {estado.rotulo}
            </label>
            <FontAwesomeIcon icon={faArrowRight} className='icone__arrow' />
          </div>
        </Render>

        <Render condition={!temInconsistencia}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <FontAwesomeIcon fontSize={15} icon={estado.icone} color={estado.cor} />
            <label
              style={{
                padding: '0',
                marginTop: '2px',
                fontSize: '14px',
                fontWeight: 'bold',
              }}
            >
              {estado.rotulo}
            </label>
          </div>
        </Render>

        <Render condition={estado.tipo === 'calcario'}>
          <Warning type='warning' style={{ fontSize: '13px' }}>
            Calcário informado da OS diferente do calcário registrado na propriedade!
          </Warning>
        </Render>

        <LineDivider />

        <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <span
            style={{
              padding: '0',
              margin: '0',
              fontSize: '14px',
              fontWeight: '600',
            }}
          >
            Safra Consultoria:
          </span>{' '}
          <p
            style={{
              padding: '0',
              margin: '0',
              fontSize: '12px',
              fontWeight: '400',
            }}
          >
            {dataSafraConsultoria?.find((item) => item?.cod === cod_safra_conta)?.nome}
          </p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <span
            style={{
              padding: '0',
              margin: '0',
              fontSize: '14px',
              fontWeight: '600',
            }}
          >
            Laboratório:
          </span>{' '}
          <p
            style={{
              padding: '0',
              margin: '0',
              fontSize: '12px',
              fontWeight: '400',
            }}
          >
            {laboratorio_nome}
          </p>
        </div>
      </div>
    </ContainerInfo>
  )
}
